import React, { forwardRef, useRef, useEffect } from "react"
import { ReactThreeFiber, extend, useThree, useFrame } from "react-three-fiber"
import { DeviceOrientationControls as DeviceOrientationControlsImpl } from "three/examples/jsm/controls/DeviceOrientationControls"
// @ts-ignore
import mergeRefs from "react-merge-refs"

extend({ DeviceOrientationControlsImpl })

type DeviceOrientationControls = ReactThreeFiber.Object3DNode<
  DeviceOrientationControlsImpl,
  typeof DeviceOrientationControlsImpl
>

declare global {
  namespace JSX {
    // eslint-disable-next-line @typescript-eslint/interface-name-prefix
    interface IntrinsicElements {
      deviceOrientationControlsImpl: DeviceOrientationControls
    }
  }
}

type Props = {
  active: boolean
  passOverInclination: (...args: any[]) => any
}

const DeviceOrientationControlsComponent = forwardRef((props: Props, ref) => {
  const controls = useRef<DeviceOrientationControlsImpl>()
  const { camera } = useThree()
  const { active, passOverInclination } = props
  useFrame(() => {
    controls.current?.update()
    const betaAbs = Math.abs(controls.current?.deviceOrientation.beta)
    if (betaAbs < 50) {
      passOverInclination(true)
    } else {
      passOverInclination(false)
    }
  })

  useEffect(() => {
    if (active) {
      controls.current?.connect()
    } else {
      controls.current?.disconnect()
    }
  }, [active])

  return (
    <deviceOrientationControlsImpl
      ref={mergeRefs([controls, ref])}
      args={[camera]}
      {...props}
    />
  )
})

export default DeviceOrientationControlsComponent
